import React, { useContext, useMemo } from 'react';

import { BasicData } from '@App';
import { Trans } from '@lingui/macro';
import { getTextColorClass, getLetters, getFormattedDate, formatNumber, getColor } from '@utils/Utils';

import './style.scss';

const AccommodationComponent = () => {
    const { trip_summary, accommodations, destinations, theme } = useContext(BasicData);

    const colors = useMemo(() => getColor(theme), [theme]);

    const legs = trip_summary?.legs?.filter(x => x.accommodation_id || x.destination_id || x.name || x.stops) || []

    const showType = legs?.some(x => x.alternate_accommodations || x.stops);

    let index = 0;

    const getPinIcon = () => {
        return <span className="accommodation-code"><i className='icon icon-pin-solid'></i><span className={`code ${getTextColorClass(`#${colors.accent}`)}`}>{getLetters(index++)}</span></span>; 
    }

    const getType = (type) => {
        return type !== "OvernightTravel" && type !== "Mobile" ? type : ""; 
    }

    return (
        <>
            <div className="accommodation-summary bg-white">
                <h2 className="text-md-center mb-[1.875rem]"><Trans>Accommodation Summary</Trans></h2>
                <table>
                    <thead>
                        <tr>
                            <th className="desktop"><h6><Trans>Start Date</Trans></h6></th>
                            <th className="mobile"><h6><Trans>Date</Trans></h6></th>
                            <th className="desktop"><h6><Trans>Accommodation</Trans></h6></th>
                            <th className="mobile"><h6><Trans>Stay</Trans></h6></th>
                            {showType && <th className="desktop"><h6><Trans>Type</Trans></h6></th>}
                            {Object.keys(destinations ?? {}).length > 0 && (<th className="desktop"><h6><Trans>Destination</Trans></h6></th>)}
                            <th className="desktop"><h6><Trans>Basis</Trans></h6></th>
                            <th><h6><Trans>Nights</Trans></h6></th>
                        </tr>
                    </thead>
                    <tbody>
                        {legs?.map((leg, i) => {
                            const accommodationPin = leg.destination_id ? getPinIcon() : <></>;
                            const date = getFormattedDate(leg.start_date, null, leg.start_day);
                            const mobileDate = leg.start_date ? date.split(' ').slice(0, 2).join(' ') : date;

                            return (
                                <React.Fragment key={i}>
                                    <tr className={`${leg.start_date || leg.start_day ? 'border-top' : ''}`}>
                                        <td className="desktop date">{date}</td>
                                        <td className="mobile date">{mobileDate}</td>
                                        <td className="mobile">
                                            <div className="stay-name">
                                                {leg.name ? leg.name : accommodations[leg.accommodation_id]?.name}
                                            </div>
                                        </td>
                                        <td className="desktop">
                                            {accommodationPin}
                                            {leg.name ? leg.name : accommodations[leg.accommodation_id]?.name}
                                        </td>
                                        {showType && <td className="desktop">{getType(leg.type)}</td>}
                                        {Object.keys(destinations ?? {}).length > 0 && (<td className="desktop">{destinations[leg.destination_id]?.name}</td>)}
                                        <td className="desktop">{leg.room_basis_code}</td>
                                        <td className="desktop">{leg.nights && <>{leg.nights} {leg.nights === 1 ? <Trans>Night</Trans> : <Trans>Nights</Trans>}</>}</td>
                                        <td className="mobile">{leg.nights && <>{formatNumber(leg.nights)}</>}</td>
                                    </tr>
                                    {
                                        leg.alternate_accommodations?.map((id, index) => (
                                            <tr className="alternate-accommodation" key={index}>
                                                <td>&nbsp;</td>
                                                <td>/ {accommodations[id].name}</td>
                                                <td className="desktop"><Trans>Alternative</Trans></td>
                                                <td className="desktop">&nbsp;</td>
                                                <td className="desktop">&nbsp;</td>
                                                <td className="desktop">&nbsp;</td>
                                            </tr>
                                        ))
                                    }
                                    {
                                        !leg.destination_id && leg.stops?.map((stop, index) => (
                                            <tr className="stop" key={index}>
                                                <td>&nbsp;</td>
                                                <td className="desktop">
                                                    {getPinIcon()}
                                                    {stop.name ? stop.name : destinations[stop.destination_id]?.name}
                                                </td>
                                                <td className="desktop">{stop.type}</td>
                                                <td>{destinations[stop.destination_id]?.name}</td>
                                                <td className="desktop">&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                        ))
                                    }
                                    {leg.destination_id && (
                                        <tr className="mobile">
                                            <td className="mobile">&nbsp;</td>
                                            <td className="mobile">
                                                <div>
                                                    <i className='icon icon-map-pin'></i>
                                                    {destinations[leg.destination_id]?.name}
                                                </div>
                                            </td>
                                            <td className="mobile">&nbsp;</td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </table>
                <h5 className="key"><Trans>Key</Trans></h5>
                {trip_summary?.basis_keys?.map((basisKey, i) => (
                    <p className="key" key={i} dangerouslySetInnerHTML={{ __html: basisKey }} />
                ))}
            </div>
        </>
    )
}

export default AccommodationComponent;